import request from '@/utils/request';
import { iResult, iUserInfo } from '@/interface/result';
import { AxiosPromise } from 'axios';

export const getUserInfo = (data: any) =>
  request({
    url: '/users/info',
    method: 'post',
    data,
  });

export const getCaptcha = () =>
  request({
    url: '/api/v1/omc/captcha',
  });

export const login = (data: any): AxiosPromise<iUserInfo> =>
  request({
    url: '/api/v1/omc/login',
    method: 'post',
    data,
  });

export const updatePWD = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/admin/pwd',
    method: 'post',
    data,
  });

/**
 * 切换品牌
 * @param data
 */
export const switchBrand = (data: { app_id: string; is_default: boolean }): Promise<any> =>
  request({
    url: '/api/v1/omc/apps/switch',
    method: 'post',
    data,
  });
